function isPrivateOrLocalHost(hostname) {
  const h = String(hostname || "").trim().toLowerCase();
  if (!h) return false;
  if (h === "localhost" || h === "127.0.0.1" || h === "::1") return true;
  if (/^10\./.test(h)) return true;
  if (/^192\.168\./.test(h)) return true;
  const m = h.match(/^172\.(\d{1,3})\./);
  if (m) {
    const second = Number(m[1]);
    if (second >= 16 && second <= 31) return true;
  }
  return false;
}

export function shouldEnableTurnstile() {
  const forceOn = String(process.env.REACT_APP_TURNSTILE_FORCE || "").toLowerCase() === "true";
  const forceOff = String(process.env.REACT_APP_TURNSTILE_ENABLED || "false").toLowerCase() === "false";
  if (forceOn) return true;
  if (forceOff) return false;
  if (typeof window !== "undefined" && isPrivateOrLocalHost(window.location.hostname)) {
    return false;
  }
  return true;
}

